var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5642 0.557463C5.93102 -0.185783 6.99086 -0.185781 7.35767 0.557465L8.57941 3.03297C8.72507 3.32811 9.00664 3.53268 9.33235 3.58001L12.0642 3.97698C12.8844 4.09616 13.212 5.10413 12.6184 5.68267L10.6416 7.60958C10.4059 7.83932 10.2984 8.17032 10.354 8.49471L10.8207 11.2156C10.9608 12.0325 10.1034 12.6554 9.36975 12.2697L6.92628 10.9851C6.63495 10.832 6.28692 10.832 5.9956 10.9851L3.55213 12.2697C2.8185 12.6554 1.96107 12.0325 2.10118 11.2156L2.56784 8.49471C2.62348 8.17032 2.51593 7.83932 2.28024 7.60958L0.303434 5.68267C-0.290083 5.10413 0.037428 4.09616 0.857648 3.97698L3.58953 3.58001C3.91524 3.53268 4.19681 3.32811 4.34247 3.03297L5.5642 0.557463Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.63d7051821ddb112681bba691fd4608f.svg";
export { ForwardRef as ReactComponent };